var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "theme-toggler",
      attrs: { "data-vv-value-path": "model", "data-vv-as": _vm.label }
    },
    [
      _c("label", { staticClass: "theme-toggler__switch" }, [
        _c("input", {
          staticClass: "theme-toggler__input",
          class: _vm.model == "1" ? "active" : "",
          attrs: { name: _vm.name, disabled: _vm.disabled },
          domProps: { value: _vm.model },
          on: {
            click: function($event) {
              _vm.stateChange(),
                _vm.$emit("click", _vm.model),
                _vm.$emit("input", _vm.model),
                _vm.$emit("change", _vm.model)
            }
          }
        }),
        _vm._v(" "),
        _c("span", { staticClass: "theme-toggler__slider" })
      ]),
      _vm._v(" "),
      _c("label", [_vm._v(_vm._s(_vm.label))])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-13550f00", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13550f00","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/ThemeToggler.vue
// module id = 603
// module chunks = 1